module.exports = __webpack_public_path__ + "img/SISGEOWEBSALA11.e00388d8.svg";